export enum OperationalSteps {
  FILING = 'FILING',
  UPLOAD_DOCUMENTS = 'UPLOAD_DOCUMENTS',
  EIN = 'EIN',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  SHARE_PURCHASE_AND_SHARE_CERTIFICATE = 'SHARE_PURCHASE_AND_SHARE_CERTIFICATE',
  COMPLETION = 'COMPLETION',
}
